export const REDUCER_NAME = 'list'




// WEBPACK FOOTER //
// ./src/modules/logistic/state/list/const.js